module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("我的优惠券")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7921c728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/myCoupons.vue
// module id = 1642
// module chunks = 1